import React, { useState } from 'react'

const text = {
    es: {
        user: 'por agent'
    },
    en: {
        user: 'per user'
    }
}

const PricingCard = ({ lang, plan, active, priceContent, actionButton = null }) => {
    const [isOpen] = useState(false)
    return (
        <div className={`pricing-card ${active && 'pricing-card--active'}`}>
            <div className="pricing-card__title-container">
                <h3 className="pricing-card__title">{plan.name}</h3>
            </div>
            <div className="pricing-card__price-container">
                {priceContent
                    ? (
                        priceContent()
                    )
                    : (
                        <h4 className="pricing-card__price">
                            <span className="pricing-card__price-text">
                                <strong>${plan.price}</strong> <span className="pricing-card__curr">USD</span>
                            </span>
                            <span className="pricing-card__bottom-text">{text[lang].user}</span>
                        </h4>
                    )}
            </div>
            {actionButton()}
            <ul className={`pricing-card__list ${isOpen && 'pricing-card__list--open'}`}>
                {plan.limits.map(feature => (
                    <>
                        <li className={`pricing-card__item ${feature.disabled && 'pricing-card__item--disabled'}`}>
                            {feature.name}
                        </li>
                    </>
                ))}
            </ul>
            <p className="pricing-card__channel-separator">Canales</p>
            <ul className={`pricing-card__list ${isOpen && 'pricing-card__list--open'}`}>
                {plan.channels.map(feature => (
                    <>
                        <li className={`pricing-card__item ${feature.disabled && 'pricing-card__item--disabled'}`}>
                            {feature.name}
                        </li>
                        {feature.quantity && (
                            <li className={'pricing-card__item pricing-card__item--number'}>
                                {feature.quantity}
                            </li>)}
                    </>
                ))}
            </ul>
            <p className="pricing-card__features-separator">Características</p>
            <ul className={`pricing-card__list ${isOpen && 'pricing-card__list--open'}`}>
                {plan.features.map(feature => (
                    <>
                        <li className={`pricing-card__item ${feature.disabled && 'pricing-card__item--disabled'}`}>
                            {feature.name}
                        </li>
                        {feature.quantity && (
                            <li className={'pricing-card__item pricing-card__item--number'}>
                                {feature.quantity}
                            </li>)}
                    </>
                ))}
            </ul>
        </div>
    )
}

export default PricingCard
